export enum FilledButtonType {
    Success = 1,
    Error = 2,
    Info = 3,
}